import React from "react";
const IconLondonTransport = (props) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ React.createElement("g", {
  transform: "translate(3.000000, 5.000000)",
  fillRule: "evenodd",
  fill: "currentColor"
}, /* @__PURE__ */ React.createElement("path", {
  d: "M18.2523364,5.24137931 L17.8411215,5.24137931 C17.0186916,1.10344828 13.317757,-2 9,-2 C4.68224299,-2 0.981308411,1.10344828 0.158878505,5.24137931 L-0.252336449,5.24137931 C-1.17757009,5.24137931 -2,6.06896552 -2,7 C-2,7.93103448 -1.17757009,8.75862069 -0.252336449,8.75862069 L0.158878505,8.75862069 C0.981308411,12.8965517 4.68224299,16 9,16 C13.317757,16 17.0186916,12.8965517 17.8411215,8.75862069 L18.2523364,8.75862069 C19.1775701,8.75862069 20,7.93103448 20,7 C20,6.06896552 19.1775701,5.24137931 18.2523364,5.24137931 Z M9,1.51724138 C11.4672897,1.51724138 13.4205607,3.06896552 14.2429907,5.24137931 L3.75700935,5.24137931 C4.57943925,3.06896552 6.53271028,1.51724138 9,1.51724138 Z M9,12.4827586 C6.53271028,12.4827586 4.57943925,10.9310345 3.75700935,8.75862069 L14.2429907,8.75862069 C13.4205607,10.9310345 11.4672897,12.4827586 9,12.4827586 Z"
})));
var IconLondonTransport_default = IconLondonTransport;
export {
  IconLondonTransport_default as default
};
